import { Component } from "react"
import { map, size, filter, set } from "lodash"
import PropTypes from "prop-types"
import { memoizedFilteredDatasets } from "modules/data-cloud/helpers"
import { createMatch } from "helpers/string"
import Dataset from "../components/dataset/dataset"
import Search from "../components/search"
import Filter from "../components/filter"
import NoResults from "../components/noResults"

import "./style.scss"

export default class Browse extends Component {
  static propTypes = {
    datasets: PropTypes.array.isRequired,
    tracking: PropTypes.shape({
      searchQuery: PropTypes.func.isRequired,
      searchFilter: PropTypes.func.isRequired,
      contactUs: PropTypes.func.isRequired,
      notFound: PropTypes.func.isRequired,
      reactivate: PropTypes.func.isRequired,
    }).isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      current: "",
      searched: props.datasets,
      filters: {},
    }
  }

  clearSearch = () => {
    const { datasets } = this.props
    this.setState({
      current: "",
      searched: datasets,
      filters: {},
    })
  }

  search = (value) => {
    const { datasets, tracking } = this.props
    // convert space to white spaces because to be able to search for
    // U+0020 : SPACE [SP] and U+00A0 : NO-BREAK SPACE [NBSP] variants
    const match = createMatch(value.replace(/\s/gi, "\\s"))

    this.setState({
      current: value,
      searched: filter(datasets, ({ id, name, description }) => match(`${id} ${name} ${description}`)),
    })
    tracking.searchQuery(value)
  }

  setFilter = ({ type, value, isActive }) => {
    const { tracking } = this.props
    const { filters } = this.state

    this.setState({
      filters: set(filters, [type, value], isActive),
    })
    tracking.searchFilter(filters)
  }

  reset = () => {
    this.setState({
      filters: {},
    })
  }

  render() {
    const { filters, searched, current } = this.state
    const { tracking } = this.props

    const filtered = memoizedFilteredDatasets(filters, current, searched)
    return <div className="browse">
      <Filter datasets={searched} filters={filters} setFilter={this.setFilter} reset={this.reset} />

      <div className="content">
        <Search count={size(filtered)} search={this.search} clear={this.clearSearch} current={current} />
        <div className="datasets">
          {map(filtered, (dataset, index) => <Dataset
            key={dataset.id}
            dataset={dataset}
            view="browse"
            actions={{ notifications: false, favourite: false }}
            style={{ zIndex: size(searched) - index }}
            tracking={{
              contactUs: () => tracking.contactUs(`${dataset.name} (${dataset.id})`),
              reactivate: () => tracking.reactivate(`${dataset.name} (${dataset.id})`),
            }}
          />)}
        </div>
        {size(filtered) === 0 && <NoResults search={current} clear={this.clearSearch} track={() => tracking.notFound(current, filters)} />}
      </div>
    </div>
  }
}
